// src/utils/dev-console.ts
function shouldShowDevConsole(showDevConsole) {
  return showDevConsole;
}

export {
  shouldShowDevConsole
};
//# sourceMappingURL=chunk-GFJW4RIM.mjs.map